const Kulfi = () => {
	return (
		<div class="menu">
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Kulfi-1.jpg"
				alt="Kulfi"
			/>
		</div>
	);
};

export default Kulfi;
